var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-preview"},[_c('img',{attrs:{"src":require("../../../../../common/images/custom-tab/doc-bg-new-h5.png")}})])
}]

export { render, staticRenderFns }